import laravelApi from "./api";
import { Order } from "@/models/order/order";
import {
  AuthError,
  APIError
} from "./error_service";

export default class UserService {
  public async getUserOrders(userRole: string): Promise<Order[]> {
    try {
      const res = await laravelApi.get("/api/legacy/quotes");
      const orders = res.data?.data?.orders || [];
      const quotes = res.data?.data?.quotes || [];
      return orders.concat(quotes);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        throw new AuthError(err.response.data?.message || "Unauthorized", 401);
      }
      throw new APIError(
        err.response?.data?.message || "Failed to fetch legacy quotes.",
        err.response?.status || 500
      );
    }
  }
}
